import { Grid, Typography } from '@mui/material';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { SarlaftVinculationProps } from './props';
import { useSarlaftVinculation } from './hook';
import { formatParams } from '../../../../../../shared/utils/params';

export const SarlaftVinculation = (props: SarlaftVinculationProps) => {
    const { formik, entailments } = useSarlaftVinculation(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Vinculación
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(entailments)}
                    label="Clase de vinculación"
                    name="typeEntailment"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeEntailment}
                    errors={formik.errors.typeEntailment}
                    value={formik.values.typeEntailment}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typeEntailment', value)
                    }
                />
            </Grid>
        </Grid>
    );
};
